import { Injectable, signal, WritableSignal } from '@angular/core';

import { MapGeoJSONFeatureWithLayer } from '@connect-services/client/services/map-popup.service';

@Injectable({
    providedIn: 'root',
})
export class FeatureService {
    public readonly data: WritableSignal<MapGeoJSONFeatureWithLayer | null> = signal(null);
    public readonly fieldInterventionEntityId: WritableSignal<string | undefined> = signal(undefined);

    public getFeatureIdentifier(): string {
        const featureProperties = Object.keys(this.data()!.properties);

        if (featureProperties.includes('businessIdentifier')) {
            return this.data()!.properties['businessIdentifier'];
        }

        if (featureProperties.includes('uuid')) {
            return this.data()!.properties['uuid'];
        }

        return this.data()!.properties[featureProperties[0]];
    }

    public resetData(): void {
        this.data.set(null);
    }

    public setData(data: MapGeoJSONFeatureWithLayer, fieldInterventionEntityId?: string): void {
        this.fieldInterventionEntityId.set(fieldInterventionEntityId);
        this.data.set(data);
    }
}
